// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__NOWTP","resendInfoText":"OnGoingPaymentBox_resendInfoText__39Qs1"};